import React from 'react';
import PropTypes from 'prop-types';
import { ListItem, Toggle } from 'material-ui';

const { bool, func, string } = PropTypes;

const ToggleFilter = ({ filterKey, onFilterChange, selectedValue, title }) => <ListItem
  primaryText={title}
  rightToggle={
    <Toggle
      value={`${filterKey}::${selectedValue}`}
      toggled={selectedValue}
      onToggle={onFilterChange}
    />
  }
/>;

ToggleFilter.propTypes = {
  filterKey: string,
  onFilterChange: func,
  selectedValue: bool,
  title: string,
};

export default ToggleFilter;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardFilter/toggleFilter.jsx